// data.js
export const nftData = [
    {
      id: 1,
      image: 'https://gateway.pinata.cloud/ipfs/QmNqYnojywtW42MwBSJmKSZUiktAsPFed7maGNUmF2sqL7',
      title: 'NFT 1',
      description: 'This is a description for NFT 1.',
      Price: '0.03ETH',
      Owner: '0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13',
      Seller: '0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13',
      tokenURI: 'https://gateway.pinata.cloud/ipfs/QmNqYnojywtW42MwBSJmKSZUiktAsPFed7maGNUmF2sqL7',
    },
    {
      id: 2,
      image: 'https://gateway.pinata.cloud/ipfs/Qmdnj8LWYhX4atMnbLT6dtoHTczDn63W88GoRzz87nZYj2',
      title: 'NFT 2',
      description: 'This is a description for NFT 2.',
      Price: '0.03ETH',
      Owner: '0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13',
      Seller: '0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13',
      tokenURI: 'https://gateway.pinata.cloud/ipfs/QmNqYnojywtW42MwBSJmKSZUiktAsPFed7maGNUmF2sqL7',

    },
    {
      id: 3,
      image: 'https://gateway.pinata.cloud/ipfs/Qmc6wXZ9EADgWsjK6JtfuUjA9V5FwtRAjpb5jMwwzXKLi7',
      title: 'NFT 3',
      description: 'This is a description for NFT 3.',
      Price: '0.03ETH',
      Owner: '0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13',
      Seller: '0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13',
      tokenURI: 'https://gateway.pinata.cloud/ipfs/QmNqYnojywtW42MwBSJmKSZUiktAsPFed7maGNUmF2sqL7',

    }
  ];
  